<template>
  <div class="interests-step">
    <div class="interests-content">
      <!-- Title -->
      <div class="title-section">
        <h2 class="step-title">{{ step.title }}</h2>
        <p v-if="step.subtitle" class="step-subtitle">{{ step.subtitle }}</p>
      </div>

      <!-- Checkboxes -->
      <div class="interests-list">
        <div
          v-for="interest in step.interests"
          :key="interest.value"
          class="interest-item"
        >
          <Checkbox
            :inputId="`interest-${interest.value}`"
            :value="interest.value"
            v-model="selectedInterests"
            @update:model-value="updateInterests"
          />
          <label :for="`interest-${interest.value}`" class="interest-label">
            {{ interest.label }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import Checkbox from 'primevue/checkbox'
import { useGiftModal } from '@/features/gift/store'
import type { GiftStep } from '@/features/gift/types/gift-config'

interface Props {
  step: GiftStep & { type: 'interests' }
}

const props = defineProps<Props>()
const giftStore = useGiftModal()

const selectedInterests = ref<string[]>([])

function updateInterests() {
  giftStore.updateGiftData(props.step.id, selectedInterests.value)
}

onMounted(() => {
  const data = giftStore.giftModal.giftData
  selectedInterests.value = data[props.step.id] || []
})
</script>

<style scoped>
.interests-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.interests-content {
  max-width: 500px;
  width: 100%;
}

.title-section {
  margin-bottom: 32px;
  text-align: left;
}

.step-title {
  font-family: 'Gilroy';
  font-size: 32px;
  line-height: 1.09;
  font-weight: 700;
  letter-spacing: -0.64px;
  color: var(--primary-blue-100);
  margin: 0 0 12px 0;
}

.step-subtitle {
  font-family: 'Inter';
  font-size: 15px;
  color: var(--primary-blue-80);
  line-height: 1.3;
  letter-spacing: -0.64px;
  margin: 0;
}

.interests-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.interest-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.interest-label {
  font-size: 16px;
  color: #1d1d1f;
  cursor: pointer;
}

@media (min-width: 1024px) {
  .title-section {
    text-align: left;
    gap: 8px;
  }

  .step-title {
    font-size: 48px;
    line-height: 1.2;
    letter-spacing: -0.04em;
  }

  .step-subtitle {
    font-size: 20px;
    line-height: 1.3;
    letter-spacing: -0.04em;
  }
}
</style>

